import {IndexedDBCache} from "finhelper"
import {ApiRequest, Builder} from "laravel-request";
import flatpickr from "flatpickr";
import {Russian} from "flatpickr/dist/l10n/ru.js"
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import {NotifyManager} from "notify-component";
import moment from "moment";
import io from 'socket.io-client';
import {register} from './serviceWorker';

register();

Builder.availableMethod = [
  ...Builder.availableMethod,
  ...[
    'whereAccount',
    'whereIncomeType',
    'whereSalaryType',
    'whereSpendingType',
    'whereObligationType',
    'wherePropertyType',
    'whereInvestType',
    'whereCurrencyType',
    'whereAccountType',
    'whereInsuranceType',
    'tasksOrder',
    'contactsOrder'
  ]
]

console.log('Builder.availableMethod inited')

IndexedDBCache.clearExpiredData();


ApiRequest.notifyClass = NotifyManager;

am4core.useTheme(am4themes_dark);
am4core.options.minPolylineStep = 5;

moment.locale('ru');
window.i18n = {};
window.io = io;

flatpickr.localize(Russian);
